// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import Layout from '@/views/todoCenter/default/workflow/layout/index'
import wechatLayout from '@/views/todoCenter/default/wechat/layout/index'

//多处用到的组件
import defaultIcon from '@/components/todoCenter/defaultIcon'
import collect from '@/components/todoCenter/collect'
import bannerImg from '@/components/todoCenter/bannerImg'
import ProcessPass from '@/components/todoCenter/process'

import VueApollo from 'vue-apollo'
import apolloProvider from './apolloConfig'
Vue.use(VueApollo);

import axios from './axiosConfig'
Vue.prototype.$axios=axios;
Vue.config.productionTip = false

//人工智能
var flag = navigator.userAgent.match(
    /(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i
);
if(flag){
  import ('@/aiDialog/css/wxAiDialog.css');
}else {
  import ('@/aiDialog/css/aiDialog.css');
}
import aiDialog from './aiDialog/js/aiDialog.js';

Vue.component('pc',Layout);
Vue.component('mobile',wechatLayout);

//定义一些全局组件
Vue.component('defaultIcon',defaultIcon);
Vue.component('collect',collect);
Vue.component('bannerImg',bannerImg);
Vue.component('ProcessPass',ProcessPass);


import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
Vue.use(ElementUI);

import ant from 'ant-design-vue'
import 'ant-design-vue/dist/antd.css'
Vue.use(ant);

/* eslint-disable no-new */
var vue = new Vue({
  el: '#app',
  data:function(){
    return {
      userName:"8980u0hp0",
      account:"",
    }
  },
  router,
  store,
  provide: apolloProvider.provide(),
  components: { 'pc':Layout ,'mobile':wechatLayout},
  render: h=>h(App)
  // template: '<mobile/>'
})
export default vue


// WEBPACK FOOTER //
// ./src/main.js